// reducer.js
import {
  SET_VALUE_CGP,
  SET_TYPE_CGP,
  SET_CURRENT_PAGE_CGP,
  SET_ORDER_CGP,
  SET_SORT_FIELD_CGP,
  SET_ACTIF_CGP,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "asc",
  sortField: "nom",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_CGP:
      return {
        ...state,
        value: action.payload,
      };
    case SET_TYPE_CGP:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_CGP:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_CGP:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_CGP:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_CGP:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
